import { Component, computed, input, output, signal } from '@angular/core';
import { ImageUrlService, MediaService } from '../../content';

import { Delivery } from '../delivery.model';
import { CultureConnectorService } from '../../cultureconnector';
import { Image } from '@frontend/core';
import { DataProcessingService } from '../../utilities';
import { ContributionsService, DeliveryStatus, DeliveryType } from '../contributions.service';
import { Culture } from '@frontend/common';


/** Subject categories whose type is a CultureConnector dimension's slug. */
const DIMENSION_SUBJECT_CATEGORIES = ['cco_dimension', 'cco_dimension_summary'];

@Component({
  selector: 'multisite-delivery-status-card',
  templateUrl: './delivery-status-card.component.html',
  styleUrls: ['./delivery-status-card.component.scss'],

  standalone: false,
})
export class DeliveryStatusCardComponent {

  delivery = input.required<Delivery>();
  deliveryType = computed<DeliveryType>(() => this.contributionsService.getDeliveryType(this.delivery()?.task?.category, this.delivery()?.task?.type));
  primaryDeliveryStatus = computed<DeliveryStatus | null>(() => this.contributionsService.getPrimaryDeliveryStatus(this.delivery()));
  deliveryStatuses = computed<DeliveryStatus[]>(() => this.contributionsService.getDeliveryStatuses(this.delivery()));
  deliveryIsLocked = computed<boolean>(() => this.contributionsService.getDeliveryLockedStatus(this.delivery()));
  showCredits = input<boolean>(true); // temporary option until we develop the credits feature. Remove when credits are implemented.
  selected = output<Delivery>();
  cloudinary_base_url = signal<string | undefined>(undefined);
  thumbnailTransformations = signal<string>('ar_16:9,w_375/');
  /**
   * The icon of the CultureConnector dimension the delivery's subject is about, whatever the task:
   * a dimension's narrower subjects and its summary both name the dimension as their type.
   */
  dimensionImageUrl = computed<string | null>(() => {
    const subject = this.delivery().subject;
    if (!subject?.type || !DIMENSION_SUBJECT_CATEGORIES.includes(subject.category ?? '')) {
      return null;
    }
    return this.cultureConnectorService.getDimension(null, subject.type)?.img_url ?? null;
  });
  truncatedSubjectDescription = computed(() => this.dataProcessingService.truncateText(this.delivery().subject?.description, 200));
  title = computed(() => {
    // A feature review has no content record, and a video's insight keeps its placeholder title
    // until staff write it: the input it was taken from names either.
    if((this.delivery().input?.kind === 'feature_review' || this.delivery().input?.kind === 'video_recording') && this.delivery().input?.name){
      return this.delivery().input.name;
    }
    if(this.delivery().insight?.s){
      return this.delivery().insight.s;
    } else if (this.delivery().differences?.[0]?.name){
      return this.delivery().differences[0].name;
    }
  });
  cultures = computed<Culture[]>(() => {
    if(this.delivery().insight?.cultures){
      return this.delivery().insight.cultures;
    } else if (this.delivery().votes?.[0]?.cultures){
      return this.delivery().votes[0].cultures;
    }
    return [];
  });

  constructor(
    private mediaService : MediaService,
    private imageUrlService : ImageUrlService,
    private cultureConnectorService : CultureConnectorService,
    private dataProcessingService : DataProcessingService,
    private contributionsService : ContributionsService,
  ) {
    this.cloudinary_base_url.set(this.mediaService.cloudinary_base_url);
  }
  getFlagUrlFromHash(hash:string,transformations : string = ''){
    return this.mediaService.getFlagUrlFromHash(hash,'',true,'.png');
  }
  getThumbnailUrl(delivery:Delivery){
    let imageUrl = this.cloudinary_base_url() + this.thumbnailTransformations() + 'concepts/keyboard-typing-midjourney_dac4c201-ec3b-4bbf-9692-b0991ce7a03c_2_n5xdft';
    let insightThumbnail : Image = delivery.insight?.images?.find(image => image.role === 'thumbnail');
    if(this.dimensionImageUrl()){
      imageUrl = this.dimensionImageUrl();
    } else if(insightThumbnail){
      imageUrl = this.imageUrlService.build(insightThumbnail, this.thumbnailTransformations());
    }
    return imageUrl;
  }
  onButtonClick(){
    this.selected.emit(this.delivery());
  }

}
